import { Fragment, useRef, useState } from "react";

import { Disclosure, Transition } from "@headlessui/react";

import { FiChevronDown } from "components/atoms/Icon/fi/FiChevronDown";

export default function AccordionBBC({ data }) {
  // Make accordions close when one is opened.
  const AccordionRefs = useRef([]); // Store accordion buttons as Refs
  const [currentAccordion, setCurrentAccordion] = useState(0); // Set the current

  function closeCurrent(e) {
    const button = e.target.closest("button"); // Get the button
    const buttonParent = button.parentElement.parentElement; // Get the buttons parent (<dt> tag here)
    const parent = buttonParent.parentElement; // Get the buttons parent parent (Disclosure as div here)
    const index = Array.prototype.indexOf.call(parent.children, buttonParent); // Find the index of the button in container

    for (let i = 0; i < AccordionRefs.current.length; i++) {
      // Loop throug
      if (
        AccordionRefs.current[i].querySelector("button") &&
        AccordionRefs.current[i]
          .querySelector("button")
          .getAttribute("aria-expanded") === "true" &&
        currentAccordion !== index // If it is opened and not the current
      ) {
        AccordionRefs.current[i].querySelector("button").click(); // Then trigger a click to close it.
      }
    }
    setCurrentAccordion(index); // And set the current
  }

  return (
    <div>
      {data?.length > 0 &&
        data?.map((item, index) => {
          return (
            <Disclosure key={index} as="div" className="mb-3 last:mb-0">
              {({ open }) => (
                <>
                  <div
                    onClick={closeCurrent}
                    ref={(el) => (AccordionRefs.current[index] = el)}
                  >
                    <Disclosure.Button className=" w-full cursor-pointer rounded-md bg-bbc-brand-100 py-3 px-10  text-left font-medium last:mb-0">
                      {item.title}

                      <FiChevronDown
                        className={` float-right mt-1 transform align-middle   ${
                          open ? "rotate-180" : "rotate-0"
                        } transition-all duration-200`}
                        size={20}
                      />
                    </Disclosure.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition-all duration-300 ease-in"
                    enterFrom="transform max-h-0 opacity-0"
                    enterTo="transform max-h-[400px] opacity-100"
                    leave="transition-all duration-300 ease-in-out"
                    leaveFrom="transform max-h-[400px] opacity-50"
                    leaveTo="transform max-h-0 opacity-0"
                  >
                    <Disclosure.Panel
                      as="div"
                      className="mx-0.5 rounded-b-xl bg-white shadow"
                    >
                      <div
                        className="paragraph py-3 px-10"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      ></div>
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          );
        })}
    </div>
  );
}
